import * as Handlebars from 'handlebars/runtime';
import deviceTypeIcon from 'templates/partials/deviceTypeIcon';
import navbar from 'templates/partials/navbar';
Handlebars.registerHelper({});
Handlebars.registerPartial({deviceTypeIcon,navbar});
export default Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<h1><span class=\"deviceName\">Device</span> <span class=\"state\"><i class=\"fas fa-plug indicator\"></i></span>\n</h1>\n\n<div id=\"messageRegion\"></div>\n";
},"useData":true});